<coa-list-element-skeleton *coaRepeatElement="3"></coa-list-element-skeleton>
